import axios from "axios";
import { message } from "antd";

const path = "";

const getHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    token: `${token}`,
  };
};

export const api = axios.create();

const axiosPost = async (
  url: string,
  request: any,
  config?: any,
  withToken = true,
  fullResponse = false
) => {
  try {
    const headers = withToken ? getHeaders() : {};
    const response = await api.post(path + url, request, {
      timeout: 600000,
      ...config,
      headers,
    });
    const { data } = response;
    return fullResponse ? response : data;
  } catch (e) {
    console.error("axiosPost", e);
    message.error(`Ошибка запроса API (${url})`);
    throw e;
  }
};

export const post = async (
  url: string,
  request: any = {},
  config?: any,
  withToken = true,
  fullResponse = false
) => {
  try {
    const response: any = await axiosPost(
      url,
      request,
      config,
      withToken,
      fullResponse
    );
    if (fullResponse) return response;
    if (response.error && response.error.length > 0) {
      if (typeof response.error !== "string") {
        response.error.forEach((error: any) => {
          message.error(`Ошибка сервера: ${error.message} (${error.unCode})`);
        });
      } else message.error(response.error);
      throw response.error;
    } else if (response.data) {
      return response.data;
    } else {
      return response;
    }
  } catch (e) {
    console.error("post", e);
    throw e;
  }
};
